import React from 'react';
import { Button, Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface FileUploaderProps {
    label: string;
    fileName: string;
    fileId: string;
    isLoading: boolean;
    disabled?: boolean;
    onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClear: () => void;
}

const FileUploader: React.FC<FileUploaderProps> = ({
    label,
    fileName,
    fileId,
    isLoading,
    disabled = false,
    onFileChange,
    onClear
}) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 450 }}>
            <Button
                variant="contained"
                component="label"
                disabled={isLoading || disabled}
            >
                {label}
                <input
                    id={fileId}
                    type="file"
                    hidden
                    accept=".xlsx,.xls"
                    onChange={onFileChange}
                    disabled={disabled}
                />
            </Button>
            <Typography color={fileName ? 'text.primary' : 'text.secondary'}>
                {fileName || 'Файл не выбран'}
            </Typography>
            {fileName && (
                <IconButton
                    size="small"
                    disabled={isLoading}
                    onClick={onClear}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        </Box>
    );
};

export default FileUploader;
